"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOOT_GAME_FADE_MS = exports.BOOT_TRANSITION_TOTAL_MS = exports.BOOT_MENU_FADE_DELAY_MS = exports.BOOT_LOGO_FADE_DELAY_MS = exports.BOOT_MENU_FADE_MS = exports.BOOT_LOGO_FADE_MS = exports.BOOT_SHEEN_MS = exports.BOOT_BG_FADE_MS = exports.BootEntranceContext = void 0;
const React = __importStar(require("react"));
/**
 * True while the first-load boot transition is playing, so the menu plays its
 * fade-in entrance in sync with the splash. False on every later mount.
 */
exports.BootEntranceContext = React.createContext(false);
// Boot transition timing (ms). The background fades in, then the logo sheens,
// then the logo fades out, and only once it's gone does the menu fade in.
exports.BOOT_BG_FADE_MS = 600;
exports.BOOT_SHEEN_MS = 1000;
exports.BOOT_LOGO_FADE_MS = 500;
exports.BOOT_MENU_FADE_MS = 500;
// The logo fades out after the background fade and the sheen have played.
exports.BOOT_LOGO_FADE_DELAY_MS = exports.BOOT_BG_FADE_MS + exports.BOOT_SHEEN_MS;
// The menu fades in only once the logo has fully faded out.
exports.BOOT_MENU_FADE_DELAY_MS = exports.BOOT_LOGO_FADE_DELAY_MS + exports.BOOT_LOGO_FADE_MS;
// Whole entrance, from the start of the transition to the menu fully shown.
exports.BOOT_TRANSITION_TOTAL_MS = exports.BOOT_MENU_FADE_DELAY_MS + exports.BOOT_MENU_FADE_MS;
// When reconnecting straight into a game/lobby there's no menu to crossfade
// into: the logo fades out first, then the background fades to reveal the game.
exports.BOOT_GAME_FADE_MS = exports.BOOT_LOGO_FADE_MS + exports.BOOT_BG_FADE_MS;
